import { Outlet, useLocation } from "react-router-dom";
import { Layout } from "antd";
import MemberNavigation from "./MemberNavigation";

const { Content } = Layout;

const OFFICE_TEAM_PATH_PREFIXES = [
	"/member/manage-employee-teams",
	"/member/assign-employee-team-members",
	"/member/manage-employee-info",
];

function Member() {
	const location = useLocation();
	const isOfficeTeamPage = OFFICE_TEAM_PATH_PREFIXES.some((path) =>
		location.pathname.startsWith(path),
	);

	if (isOfficeTeamPage) {
		return <Outlet />;
	}

	return (
		<Layout className="member-layout">
			<MemberNavigation />
			<Layout className="member-content-layout">
				<Content className="member-content">
					<Outlet />
				</Content>
			</Layout>
		</Layout>
	);
}

export default Member;
